import React, { useCallback, useEffect, useState } from 'react';
import { useTemplate, useDistribution } from '../../../../hooks';
import { getTemplateUrl } from '../../../../services/StorageService';
import { Template } from '../../../../dtos';
import { Container } from './styles';

const Templates: React.FC = () => {
    const [selectedIndex, setSelectedIndex] = useState<number>(-1);
    const { templates } = useTemplate();
    const { template, selectTemplate } = useDistribution();

    useEffect(() => {
        if (template) {
            const index = templates.findIndex(({ id }) => id === template.id);
            setSelectedIndex(index);
        }
    }, [template, templates]);

    const handleSelectTemplate = useCallback((index: number, template: Template) => {
        setSelectedIndex(index);
        selectTemplate(template);
    }, [selectTemplate]);

    return (
        <Container>
            <span>Selecione o template da cortesia:</span>
            <ul>
                {templates.map((template, index) => (
                    <li
                        key={template.id}
                    >
                        <input
                            id={`distribution.templates${index}.radio`}
                            type="radio"
                            checked={index === selectedIndex}
                            onChange={() => handleSelectTemplate(index, template)}
                        />
                        <div>
                            <img
                                src={getTemplateUrl(template.uuid, template.backgroundEmailFile)}
                                alt={template.name}
                            />
                            <span>{template.name}</span>
                        </div>
                    </li>
                ))}
            </ul>
        </Container>
    );
};

export { Templates };
